// Utilitários da promoção de whitelabel, compartilhados pela fila e pela revisão.

export const STATUS_LABEL = {
    pendente: 'Pendente', aplicada: 'Aplicada', recusada: 'Recusada',
    cancelada: 'Cancelada', expirada: 'Expirada', desfeita: 'Desfeita',
};
export const STATUS_CLASS = {
    pendente: 'vr-chip-pending', aplicada: 'vr-chip-granted', recusada: 'vr-chip-denied',
    cancelada: 'vr-chip-denied', expirada: 'vr-chip-denied', desfeita: 'vr-chip-partial',
};
export const ORIGEM_LABEL = { qa: 'QA', hmg: 'Homologação', prod: 'Produção' };
export const ACAO_LABEL = {
    criar: 'Novo', editar: 'Edita', sem_mudanca: 'Igual', recusado: 'Recusado',
};

// Datas da API vêm em ISO com fuso; mostradas em São Paulo.
export const brDateTime = (iso) => {
    if (!iso) return '—';
    const s = String(iso);
    const dt = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : s + 'Z');
    if (isNaN(dt)) return s;
    return dt.toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo',
    });
};

export const tempoRestante = (iso) => {
    const ms = new Date(iso).getTime() - Date.now();
    if (isNaN(ms)) return '';
    if (ms <= 0) return 'expirou';
    const min = Math.round(ms / 60000);
    return min >= 60 ? `expira em ${Math.floor(min / 60)}h${String(min % 60).padStart(2, '0')}` : `expira em ${min} min`;
};

// Nome legível da fase: "Programa · fase N" a partir da chave `programa␟ordem`.
export const nomeFase = (it) => {
    if (it.fase && it.fase.nome) return `${it.fase.programa} › ${it.fase.nome}`;
    if (it.phase_key) return it.phase_key.replace('␟', ' · fase ');
    return '—';
};

/**
 * Diferenças entre dois configs, por caminho de chave.
 *
 * Lista de objetos com `id` é casada PELO id, não pela posição: inserir um nó no meio de uma
 * lista não pode aparecer como "todos os nós seguintes mudaram". Foi assim que uma troca de
 * posição de banner passou despercebida numa comparação por índice (LM, 06/10/2026).
 */
export function diffConfigs(antes, depois, limite = 400) {
    const out = [];
    const tipo = (v) => (Array.isArray(v) ? 'array' : v === null ? 'null' : typeof v);
    const comId = (arr) => arr.length > 0 && arr.every((x) => x && typeof x === 'object' && !Array.isArray(x) && x.id !== undefined);
    const walk = (a, b, path) => {
        if (out.length >= limite) return;
        if (a === undefined) { out.push({ path, tipo: 'adicionado', depois: b }); return; }
        if (b === undefined) { out.push({ path, tipo: 'removido', antes: a }); return; }
        const ta = tipo(a); const tb = tipo(b);
        if (ta !== tb) { out.push({ path, tipo: 'alterado', antes: a, depois: b }); return; }
        if (ta === 'array') {
            if (comId(a) && comId(b)) {
                const ma = new Map(a.map((x) => [String(x.id), x]));
                const mb = new Map(b.map((x) => [String(x.id), x]));
                const ordemA = a.map((x) => String(x.id)).filter((k) => mb.has(k));
                const ordemB = b.map((x) => String(x.id)).filter((k) => ma.has(k));
                if (ordemA.join('\u0000') !== ordemB.join('\u0000')) {
                    out.push({ path, tipo: 'reordenado', antes: ordemA, depois: ordemB });
                }
                for (const [k, v] of ma) walk(v, mb.get(k), `${path}[id=${k}]`);
                for (const [k, v] of mb) if (!ma.has(k)) walk(undefined, v, `${path}[id=${k}]`);
                return;
            }
            const n = Math.max(a.length, b.length);
            for (let i = 0; i < n; i += 1) walk(a[i], b[i], `${path}[${i}]`);
            return;
        }
        if (ta === 'object') {
            const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
            for (const k of [...keys].sort()) walk(a[k], b[k], path ? `${path}.${k}` : k);
            return;
        }
        if (a !== b) out.push({ path, tipo: 'alterado', antes: a, depois: b });
    };
    walk(antes || {}, depois || {}, '');
    return { itens: out, truncado: out.length >= limite };
}

export const curto = (v) => {
    if (v === undefined) return '—';
    const s = JSON.stringify(v);
    return s && s.length > 160 ? `${s.slice(0, 157)}…` : s;
};

// "Conferida nesta sessão": a revisão marca a proposta ao abrir o Resumo; o lote só deixa aprovar
// as marcadas. Fica no sessionStorage, então vale só para esta aba e some ao fechar.
const CONFERIDA_KEY = 'wl-promo-conferidas:v1';
export const lerConferidas = () => {
    try { return JSON.parse(sessionStorage.getItem(CONFERIDA_KEY) || '{}'); } catch (e) { return {}; }
};
export const marcarConferida = (promotionId) => {
    try {
        const m = lerConferidas();
        m[String(promotionId)] = Date.now();
        sessionStorage.setItem(CONFERIDA_KEY, JSON.stringify(m));
    } catch (e) { /* sem storage: o lote não libera a aprovação */ }
};
